export default __webpack_public_path__ + "static/media/coachbetter_Logo_Black.ff2616f8.svg";